import qs from 'qs'

export default class HttpService {
  constructor(...attributes) {
    if (this.constructor === HttpService) {
      throw new TypeError(
        'Abstract class "HttpService" cannot be instantiated directly',
      )
    }

    Object.assign(this, ...attributes)

    if (this._service === undefined) {
      throw new Error('You must declare default service.')
    }

    if (this._$http === undefined) {
      throw new Error('You must set $http property')
    }
  }

  get $http() {
    return this._$http
  }

  get service() {
    return this._service
  }

  /**
   * @readonly
   * @memberof BaseModel
   */
  get model() {
    return this._model
  }

  /**
   * @readonly
   * @memberof BaseModel
   */
  get resourceUrl() {
    return `${this.service}/${this.model}`
  }

  /**
   * @param {Object} config
   * @returns {Promise}
   * @memberof BaseModel
   */
  request(config) {
    return this.$http.request(config)
  }

  /**
   * @param {String} url
   * @param {Object} config
   * @returns {Promise}
   * @memberof BaseModel
   */
  get(url, config = {}) {
    return this.$http.get(url, config)
  }

  /**
   * @param {String} url
   * @param {Object} config
   * @returns {Promise}
   * @memberof BaseModel
   */
  post(url, data, config) {
    return this.$http.post(url, data, config)
  }

  /**
   * POST method with query string parameters
   * @param {String} url
   * @param {Object} data
   * @param {Object} config
   * @returns {Promise}
   */
  postQS(url, data, config) {
    return this.$http.post(url, qs.stringify(data), config)
  }

  /**
   * @param {String} url
   * @param {Object} config
   * @returns {Promise}
   * @memberof BaseModel
   */
  patch(url, config) {
    return this.$http.patch(url, config)
  }

  /**
   * @param {String} url
   * @param {Object} config
   * @returns {Promise}
   * @memberof BaseModel
   */
  delete(url, config) {
    return this.$http.delete(url, config)
  }

  /**
   * @param {String} url
   * @param {Object} config
   * @returns {Promise}
   * @memberof BaseModel
   */
  put(url, config) {
    return this.$http.put(url, config)
  }
}
